import { cn } from '@/lib/utils';

type BadgeProps = {
  children: React.ReactNode;
  variant?: 'default' | 'secondary';
  className?: string;
};

export const Badge = ({ children, variant = 'default', className }: BadgeProps) => {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium border',
        variant === 'default' && 'bg-slate-100 text-slate-800 border-slate-200',
        variant === 'secondary' && 'bg-slate-700 text-slate-200 border-slate-600',
        className
      )}
    >
      {children}
    </span>
  );
}; 